import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getBuiDashboardData(
  oauthTokenHeader: string,
  website_shared_uid: string[],
  QUERY_ID: any,
  dimensions: string[],
  type: string,
  selectedAll: boolean | string,
  start_date?: any,
  end_date?: any,
  periodType?: any
) {
  let query = "";

  if (
    (typeof selectedAll === "boolean" && selectedAll) ||
    (typeof selectedAll === "string" && selectedAll === "true")
  ) {
    if (type === "site") {
      if (periodType) {
        query = `${apiUrl}//biz_layer_query/run/${QUERY_ID}/?period_type=${periodType}&type=${type}`;
      } else {
        query = `${apiUrl}//biz_layer_query/run/${QUERY_ID}/?start_date=${start_date}&end_date=${end_date}&type=${type}`;
      }

      // adding the website_shared_uid
      // eslint-disable-next-line
      website_shared_uid?.map((item: any) => {
        if (Array.isArray(item)) {
          // eslint-disable-next-line
          item?.map((site: any) => {
            query += "&website_shared_uid=" + (site?.value ? site.value : site);
          });
        } else {
          query += "&website_shared_uid=" + (item?.value ? item.value : item);
        }
      });
    } else {
      const uid = website_shared_uid[0] as any;
      if (periodType) {
        query = `${apiUrl}//biz_layer_query/run/${QUERY_ID}/?period_type=${periodType}&type=dimension&website_shared_uid=${
          uid?.value ? uid?.value : uid
        }`;
      } else {
        query = `${apiUrl}//biz_layer_query/run/${QUERY_ID}/?start_date=${start_date}&end_date=${end_date}&type=dimension&website_shared_uid=${
          uid?.value ? uid?.value : uid
        }`;
      }
    }

    // adding the dimensions
    // eslint-disable-next-line
    dimensions?.map((item: any) => {
      query += "&dimension=" + item;
    });
  } else {
    if (periodType) {
      query = `${apiUrl}//biz_layer_query/run/${QUERY_ID}/?period_type=${periodType}&type=${type}`;
    } else {
      query = `${apiUrl}//biz_layer_query/run/${QUERY_ID}/?start_date=${start_date}&end_date=${end_date}&type=${type}`;
    }

    // adding the dimensions
    // eslint-disable-next-line
    dimensions?.map((item: any) => {
      if (Array.isArray(item)) {
        // eslint-disable-next-line
        item?.map((dim: any) => {
          query +=
            "&dimension=" + (dim?.value ? dim.value : dim?.dimension_name);
        });
      } else {
        query +=
          "&dimension=" + (item?.value ? item.value : item?.dimension_name);
      }
    });

    // adding the website_shared_uid
    // eslint-disable-next-line
    website_shared_uid?.map((item: any) => {
      if (Array.isArray(item)) {
        // eslint-disable-next-line
        item?.map((site: any) => {
          query += "&website_shared_uid=" + (site?.value ? site.value : site);
        });
      } else {
        query += "&website_shared_uid=" + (item?.value ? item.value : item);
      }
    });
  }
  return fetchWrapper.get(query, oauthTokenHeader);
}

function getBuiDashboardData_loadedFromTotal(
  oauthTokenHeader: string,
  website_shared_uid: string[],
  QUERY_ID: any,
  dimensions: string[],
  type: string,
  selectedAll: boolean | string,
  selecteDate: any,
  actionType: any
) {
  let query = "";

  if (
    (typeof selectedAll === "boolean" && selectedAll) ||
    (typeof selectedAll === "string" && selectedAll === "true")
  ) {
    if (type === "site") {
      query = `${apiUrl}//biz_layer_query/run/${QUERY_ID}/?start_date=${selecteDate}&end_date=${selecteDate}&type=${type}&action_type=${actionType}`;

      // adding the website_shared_uid
      // eslint-disable-next-line
      website_shared_uid?.map((item: any) => {
        if (Array.isArray(item)) {
          // eslint-disable-next-line
          item?.map((site: any) => {
            query += "&website_shared_uid=" + (site?.value ? site.value : site);
          });
        } else {
          query += "&website_shared_uid=" + (item?.value ? item.value : item);
        }
      });
    } else {
      const uid = website_shared_uid[0] as any;
      query = `${apiUrl}//biz_layer_query/run/${QUERY_ID}/?start_date=${selecteDate}&end_date=${selecteDate}&type=dimension&action_type=${actionType}&website_shared_uid=${
        uid?.value ? uid?.value : uid
      }`;
    }

    // adding the dimensions
    // eslint-disable-next-line
    dimensions?.map((item: any) => {
      query += "&dimension=" + item;
    });
  } else {
    query = `${apiUrl}//biz_layer_query/run/${QUERY_ID}/?start_date=${selecteDate}&end_date=${selecteDate}&type=${type}&action_type=${actionType}`;

    // adding the dimensions
    // eslint-disable-next-line
    dimensions?.map((item: any) => {
      if (Array.isArray(item)) {
        // eslint-disable-next-line
        item?.map((dim: any) => {
          query +=
            "&dimension=" + (dim?.value ? dim.value : dim?.dimension_name);
        });
      } else {
        // eslint-disable-next-line
        item?.split(",")?.map((val: string) => {
          query += "&dimension=" + val;
        });
      }
    });

    // adding the website_shared_uid
    // eslint-disable-next-line
    website_shared_uid?.map((item: any) => {
      if (Array.isArray(item)) {
        // eslint-disable-next-line
        item?.map((site: any) => {
          query += "&website_shared_uid=" + (site?.value ? site.value : site);
        });
      } else {
        // eslint-disable-next-line
        item?.split(",")?.map((val: string) => {
          query += "&website_shared_uid=" + val;
        });
      }
    });
  }
  return fetchWrapper.get(query, oauthTokenHeader);
}

function getAllDimesnionsForViewOrganizationalSummary(
  oauthTokenHeader: string
) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/dimensions/`,
    oauthTokenHeader
  );
}

export const buiDashboardService = {
  getBuiDashboardData,
  getAllDimesnionsForViewOrganizationalSummary,
  getBuiDashboardData_loadedFromTotal,
};
